<template>
    <div>
        <component v-for="(comData) in components"
                   :is="comData.com"
                   :key="comData.id"
                   :ref="comData.id">
        </component>
    </div>
</template>

<script>
import ViewModal from './ViewModal.vue'
export default {
  name: 'TEST',
  components: { ViewModal },
  data () {
    return {
      components: [
        {
          com: ViewModal,
          id: 'public'
        }
      ]
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    async show (...args) {
      // 找到那个实例
      const showId = args[0].id || 'public'
      if (!this.components.find(el => el.id === showId)) {
        this.components.push({
          com: ViewModal,
          id: showId
        })
        await this.$nextTick()
      }
      return this.$refs[showId][0].show(...args)
    }
  },
  created () {
    this.$root.__modalContainer = this
  }
}
</script>

<style scoped lang="scss">
    .TEST {

    }
</style>



// WEBPACK FOOTER //
// src/utils/plugins/zModel/ModalContainer.vue